import React, { useEffect, useRef , useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { removeTrailingSlash } from '../../utils/common';
import { useContext } from 'react';
import { SocketContext } from '../../contexts/SocketContextProvider';
import { setPage } from '../../redux/actions/commonActions';
import './Header.scss'

import { useLocation } from 'react-router-dom'
import { locale } from 'moment';


const AppBarStyled = styled.div`
    height: 65px;
    background-color: #af0000;
    color:  #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
`

const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Title = styled.div`
    display: inline-block;
    margin-right: 6px;
    font-size: 22px;
    font-weight: 600;
    font-family: 'Nunito', sans-serif;
`

const Button = styled.button`
    cursor: pointer;
    color: #fff;
    border: none;
    outline: none;
    background:none;
    &:focus{
    outline: 2px dashed var(--chat-client-light-blue);
}`

const TitleBar = (config) => { 
    return <div className='title-container'>
        <div className="logo-container">
            <>
                <img id="dafabet-logo"  src={ config.config?.Template?.BrandLogo?.data?.attributes?.url } alt={config.config?.Template?.BrandLogo?.data?.attributes?.alternativeText} loading="lazy"/>
            </>
        </div>
    </div>
}

function Header() {
    
    const dispatch = useDispatch()

    const { ui, common } = useSelector(state=>state)
    const config = ui?.config?.attributes;

    //@ts-ignore
    const { messages } = useContext(SocketContext)


    const clickPostSurvay = event => {
    // navigate('/post-chat-survey')
    dispatch(setPage('post-chat-survey'));
    document.body.style.overflow = "auto";
    }

    const clickExitConfirm = ()=>{
    // navigate('/exit-confirm')
    dispatch(setPage('exit-confirm'));
    document.body.style.overflow = "auto";
    }

    const clickCallUS = () => {
    // navigate('/call-confirm')
    dispatch(setPage('call-confirm'));
    document.body.style.overflow = "auto";
    }

    const printChat = () => {
        console.log(messages);
    let newWindow = window.open('', 'newwin', 'width=600, height=750');
    messages.forEach( (message) => {
        const dateStr = message.receivedAt;
        const date = new Date(dateStr);
        date.setMilliseconds(0);
        
        const isEvent = (message.senderType === "PARTICIPANT_ADDED") || (message.senderType === "PARTICIPANT_REMOVED");
        let timeStamp = new Date(message.receivedAt).getTime();
        
        if(isEvent) {
            timeStamp = message.lastUpdatedTimestamp;
        }
        
        const formattedDate = new Date(timeStamp).toLocaleString();
        
        let participantText = "";
        if (isEvent) {
            if (message.senderType === "PARTICIPANT_ADDED") {
                participantText = "Agent joined";
            } else if (message.senderType === "PARTICIPANT_REMOVED") {
                participantText = "Agent left";
            }
        } else {
            participantText = message.senderParticipantType || "Unknown";
        }
        
        newWindow.document.write('<p><span style="font-weight:bold">' + participantText + "</span> at " + formattedDate + '</p>');
        newWindow.document.write('<p>' + message.body.elementText.text + '</p>');
    })

    newWindow.document.close();
    newWindow.focus();

    // check if iOS
    //@ts-ignore
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
        // delay for safari
        setTimeout(function () {
            newWindow.print();
        }, 1000);
    } else {
        newWindow.print();
        setTimeout(function () {
            newWindow.close();
        }, 1000);
    }
    }

    let hide_print = false;
    if(config?.print_hide != '1') {
    hide_print = true;
    }
    let appBarCssId = ""

    if (config?.Template?.Brand ==='nextbet' && config?.locale ==='pt') {
        appBarCssId = 'nextbet-pt';
    }

    return (
        <AppBarStyled className='app-bar' id={appBarCssId}>
            <TitleBar  config={config}/>
            {
            (common?.common?.page == 'chat') ?
                <div className="chat-tools">
                    <>
                    { (hide_print)?
                    <button className="print-chat tooltipstered" title={config.Tooltips?.PrintTooltip} onClick={printChat}>
                        <span className="print-chat-icon">
                        </span>
                    </button>
                    : null } 
                    { (config.CallUs?.EnableCallUsButton)?
                    <button id="leaveChatButton" title={config.Tooltips?.CallUsTooltip} className="leave-chat leave-chat-right-br tooltipstered" onClick={clickCallUS}>
                        <span className="call-us-icon">
                        
                        </span>
                    </button> 
                        : null } 
                    
                    { (true)?
                        <button id="leaveChatButton" title={config.Tooltips?.LeaveTooltip}  onClick={clickExitConfirm} className="leave-chat leave-chat-right-br">
                            <span className="leaveChatIcon leave-chat-icon direct-leave-chat-icon">
                            </span>
                        </button>
                    : null }
                </>
                </div>
            : null
            }
        </AppBarStyled>
    )
}

export default Header;
